import { Button } from '@material-ui/core';
import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import Chip from '@mui/material/Chip';
import { NotificationManager } from 'react-notifications';
import 'react-phone-number-input/style.css'
import PhoneInput, { formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input';
import http from '../../api';
import appRoute from '../../Route/appRoutes';
import { useHistory } from 'react-router-dom';
import './notifi.css';

function AddNotifi() {
    const closeSidebar = useSelector(state => state.reducer.closeSidebar);
    const history = useHistory();
    const [email1, setEmail1] = useState("");
    const [emailArray1, setEmailArray1] = useState([]);
    const [emailError1, setEmailError1] = useState("");
    const [email2, setEmail2] = useState("");
    const [emailArray2, setEmailArray2] = useState([]);
    const [emailError2, setEmailError2] = useState("");
    const [email3, setEmail3] = useState("");
    const [emailArray3, setEmailArray3] = useState([]);
    const [emailError3, setEmailError3] = useState("");
    const [sms1, setSms1] = useState("");
    const [smsArray1, setSmsArray1] = useState([]);
    const [smsError1, setSmsError1] = useState("")
    const [sms2, setSms2] = useState("");
    const [smsArray2, setSmsArray2] = useState([]);
    const [smsError2, setSmsError2] = useState("")
    const [sms3, setSms3] = useState("");
    const [smsArray3, setSmsArray3] = useState([]);
    const [smsError3, setSmsError3] = useState("");
    // const [streamName, setStreamName] = useState("");
    // const [streamUrl, setStreamUrl] = useState("");
    // const [streamDesc, setstreamDesc] = useState("");
    const [inputValues, setInputValues] = useState({
        alert_handling_track_name: '',
        alert_handling_track_desc: '',
        notification_interval: '',
        escalation_00_emails: '',
        escalation_00_sms: '',
        escalation_01_emails: '',
        escalation_01_sms: '',
        escalation_02_emails: '',
        escalation_02_sms: '',
    });

    const ListItem = styled('li')(({ theme }) => ({
        margin: theme.spacing(0.5),
    }));

    const isInList = (value, inputType) => {
        if (inputType === 'email1') {
            return emailArray1.includes(value);
        } else if (inputType === 'email2') {
            return emailArray2.includes(value);
        } else if (inputType === 'email3') {
            return emailArray3.includes(value);
        } else if (inputType === 'sms1') {
            return smsArray1.includes(value);
        } else if (inputType === 'sms2') {
            return smsArray2.includes(value);
        } else if (inputType === 'sms3') {
            return smsArray3.includes(value);
        }
    }

    const isEmail = (value) => {
        return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(value);
    }

    const isValidEmail = (value, emailNo) => {
        let error = null;
        if (isInList(value, emailNo)) {
            error = `${value} has already been added.`;
        }
        if (!isEmail(value)) {
            error = `${value} is not a valid email address.`;
        }
        if (error) {
            if (emailNo === 'email1') {
                setEmailError1(error)
            } else if (emailNo === 'email2') {
                setEmailError2(error)

            } else if (emailNo === 'email3') {
                setEmailError3(error)
            }
            NotificationManager.error(error);
            return false;
        }
        return true;
    }

    const inputKeyDown = (evt, inputType) => {
        if (["Enter", ","].includes(evt.key)) {
            evt.preventDefault();
            if (inputType === 'email1') {
                let value = email1.trim();
                if (value && isValidEmail(value, inputType)) {
                    setEmailArray1([...emailArray1, value]);
                    setEmail1('')
                }
            } else if (inputType === 'email2') {
                let value = email2.trim();
                if (value && isValidEmail(value, inputType)) {
                    setEmailArray2([...emailArray2, value]);
                    setEmail2('')
                }
            } else if (inputType === 'email3') {
                let value = email3.trim();
                if (value && isValidEmail(value, inputType)) {
                    setEmailArray3([...emailArray3, value]);
                    setEmail3('')
                }
            } else if (inputType === 'sms1') {
                console.log(sms1)
                let value = sms1.trim();
                setSmsError1('');
                if (!isValidPhoneNumber(sms1)) {
                    setSmsError1(`${sms1} is not valid Number`);
                    NotificationManager.error(`${sms1} is not valid Number`);
                } else if (isInList(formatPhoneNumberIntl(value), inputType)) {
                    setSmsError1(`${value} has already been added.`);
                    NotificationManager.error(`${value} has already been added.`);
                } else if (value && isValidPhoneNumber(value)) {
                    setSmsArray1([...smsArray1, formatPhoneNumberIntl(value)]);
                    setSms1('')
                }
            } else if (inputType === 'sms2') {
                let value = sms2.trim();
                setSmsError2('');
                if (!isValidPhoneNumber(sms2)) {
                    setSmsError2(`${sms2} is not valid Number`);
                    NotificationManager.error(`${sms2} is not valid Number`);
                } else if (isInList(formatPhoneNumberIntl(value), inputType)) {
                    setSmsError2(`${value} has already been added.`);
                    NotificationManager.error(`${value} has already been added.`);
                } else if (value && isValidPhoneNumber(value)) {
                    setSmsArray2([...smsArray2, formatPhoneNumberIntl(value)]);
                    setSms2('')
                }
            } else if (inputType === 'sms3') {
                let value = sms3.trim();
                setSmsError3('');
                if (!isValidPhoneNumber(sms3)) {
                    setSmsError3(`${sms3} is not valid Number`);
                    NotificationManager.error(`${sms3} is not valid Number`);
                } else if (isInList(formatPhoneNumberIntl(value), inputType)) {
                    setSmsError3(`${value} has already been added.`);
                    NotificationManager.error(`${value} has already been added.`);
                } else if (value && isValidPhoneNumber(value)) {
                    setSmsArray3([...smsArray3, formatPhoneNumberIntl(value)]);
                    setSms3('')
                }
            }
        }
    }

    const emailPaste = (evt, emailNo) => {
        evt.preventDefault();
        let paste = evt.clipboardData.getData("text");
        let emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);
        if (emailNo === 'email1') {
            setEmail1(paste);
            setEmailError1('');
        } else if (emailNo === 'email2') {
            setEmail2(paste);
            setEmailError2('');
        } else if (emailNo === 'email3') {
            setEmail3(paste);
            setEmailError3('');
        }
        // if (isInList(paste, emailNo)) {
        //     error = `${emails} has already been added.`;
        //     if (emailNo === 'email1') {
        //         setEmailError1(error)
        //     } else if (emailNo === 'email2') {
        //         setEmailError2(error)
        //     } else if (emailNo === 'email3') {
        //         setEmailError3(error)
        //     }
        // } 
        if (emails) {
            // let toBeAdded = emails.filter(email => !isInList(email, emailNo));
            if (emailNo === 'email1') {
                // setEmailArray1([...emailArray1, ...toBeAdded]);
                // setEmail1('');
                setEmailError1('');
            } else if (emailNo === 'email2') {
                // setEmailArray2([...emailArray2, ...toBeAdded]);
                // setEmail2('');
                setEmailError2('');
            } else if (emailNo === 'email3') {
                // setEmailArray3([...emailArray3, ...toBeAdded]);
                // setEmail3('');
                setEmailError3('');
            }
        }
        //  else {
        //     if (emailNo === 'email1') {
        //         setEmail1(paste);
        //         setEmailError1(`${paste} is not a valid email address`)
        //     } else if (emailNo === 'email2') {
        //         setEmail2(paste);
        //         setEmailError2(`${paste} is not a valid email address`)
        //     } else if (emailNo === 'email3') {
        //         setEmail3(paste);
        //         setEmailError3(`${paste} is not a valid email address`)
        //     }
        //     // NotificationManager.error(`${paste} is not a valid email address`);
        // }
    }

    const escInput = (event, inputType) => {
        if (inputType === 'email1') {
            setEmail1(event.target.value);
            setEmailError1('');
        } else if (inputType === 'email2') {
            setEmail2(event.target.value);
            setEmailError2('');
        } else if (inputType === 'email3') {
            setEmail3(event.target.value);
            setEmailError3('');
        } else if (inputType === 'sms1') {
            setSms1(event);
            setSmsError1('');
        } else if (inputType === 'sms2') {
            setSms2(event);
            setSmsError2('');
        } else if (inputType === 'sms3') {
            setSms3(event);
            setSmsError3('');
        }
    }

    const handleDelete = (chipToDelete, arrayType) => {
        if (arrayType === 'email1') {
            setEmailArray1((chips) => chips.filter((chip) => chip !== chipToDelete));
        } else if (arrayType === 'email2') {
            setEmailArray2((chips) => chips.filter((chip) => chip !== chipToDelete));
        } else if (arrayType === 'email3') {
            setEmailArray3((chips) => chips.filter((chip) => chip !== chipToDelete));
        } else if (arrayType === 'sms1') {
            setSmsArray1((chips) => chips.filter((chip) => chip !== chipToDelete));
        } else if (arrayType === 'sms2') {
            setSmsArray2((chips) => chips.filter((chip) => chip !== chipToDelete));
        } else if (arrayType === 'sms3') {
            setSmsArray3((chips) => chips.filter((chip) => chip !== chipToDelete));
        }
    }

    const onSave = () => {
        if (!emailArray1.length) {
            NotificationManager.error('Please fill atleast Escalation Email-1');
        } else if (!smsArray1.length) {
            NotificationManager.error('Please fill atleast Escalation SMS-1');
        } else {
            let finalEmail1 = '';
            emailArray1.forEach((ele, index) => {
                if (index < (emailArray1.length - 1)) {
                    finalEmail1 += `${ele},`
                } else {
                    finalEmail1 += `${ele}`
                }
            })
            let finalEmail2 = '';
            emailArray2.forEach((ele, index) => {
                if (index < (emailArray2.length - 1)) {
                    finalEmail2 += `${ele},`
                } else {
                    finalEmail2 += `${ele}`
                }
            })
            let finalEmail3 = '';
            emailArray3.forEach((ele, index) => {
                if (index < (emailArray3.length - 1)) {
                    finalEmail3 += `${ele},`
                } else {
                    finalEmail3 += `${ele}`
                }
            })
            let finalSms1 = '';
            smsArray1.forEach((ele, index) => {
                if (index < (smsArray1.length - 1)) {
                    // finalSms1 += `${ele.replaceAll(" ", "")}, `
                    finalSms1 += `${ele},`
                } else {
                    finalSms1 += `${ele}`
                }
            })
            let finalSms2 = '';
            smsArray2.forEach((ele, index) => {
                if (index < (smsArray2.length - 1)) {
                    finalSms2 += `${ele},`
                } else {
                    finalSms2 += `${ele}`
                }
            })
            let finalSms3 = '';
            smsArray3.forEach((ele, index) => {
                if (index < (smsArray3.length - 1)) {
                    finalSms3 += `${ele},`
                } else {
                    finalSms3 += `${ele}`
                }
            })
            const body = {
                "alert_handling_track_id": 0,
                "oper": "I",
                "alert_handling_track_name": inputValues.alert_handling_track_name,
                "alert_handling_track_desc": inputValues.alert_handling_track_desc,
                "notification_interval": parseInt(inputValues.notification_interval),
                "escalation_00_emails": finalEmail1,
                "escalation_00_sms": finalSms1,
                "escalation_01_emails": finalEmail2,
                "escalation_01_sms": finalSms2,
                "escalation_02_emails": finalEmail3,
                "escalation_02_sms": finalSms3,
                "isactive": "Y",
                "createdby": 1
            };
            http.post(`api/v1/Alert/Post`,
                body)
                .then((res) => {
                    if (res.Success) {
                        NotificationManager.success(res.ResultMessage, '', 3000);
                        setTimeout(() => {
                            history.push(appRoute.NOTIFI)
                        }, 3500);
                    } else {
                        NotificationManager.error(res.ResultMessage, '', 3000);
                    }
                }).catch((error) => {
                    console.log(error)
                    NotificationManager.error('Something went wrong', '', 3000);
                })
        }
    }

    return (
        <div className={`mainSection integrationComponent ${closeSidebar ? 'maxMainSection' : 'minMainSection'}`}  >
            <div className='mainSectionHeading'>
                <span>Alert Handling</span>
            </div>
            <div className='container-fluid notifiPage'>
                <div className='row'>
                    <div className='col-12 infoEmail'>
                        <p>Note :-</p>
                        <ol>
                            <li>Use comma(,) or Enter to set values!</li>
                            <li>Star marked fields are necessary!</li>
                        </ol>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-4'>
                        <p>Track Name</p>
                    </div>
                    <div className='col-8'>
                        <input type='text' placeholder='Track Name' className='form-control' value={inputValues.alert_handling_track_name} onChange={(e) => setInputValues({ ...inputValues, alert_handling_track_name: e.target.value })} />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-4'>
                        <p>Track Description</p>
                    </div>
                    <div className='col-8'>
                        <input type='text' placeholder='Track Description' className='form-control' value={inputValues.alert_handling_track_desc} onChange={(e) => setInputValues({ ...inputValues, alert_handling_track_desc: e.target.value })} />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-4'>
                        <p>Interval</p>
                    </div>
                    <div className='col-8'>
                        <input type='text' placeholder='Interval' className='form-control' value={inputValues.notification_interval} onChange={(e) => setInputValues({ ...inputValues, notification_interval: e.target.value })} />
                    </div>
                </div>
                <fieldset className='fieldset'>
                    <legend>Escalation Email</legend>
                    <div className='row'>
                        <div className='col-4'>
                            <p>Escalation Email-1 <span><sup>*</sup></span></p>
                        </div>
                        <div className='col-8'>
                            {emailArray1.length ?
                                <ul className='chipList'>
                                    {emailArray1.map((data, index) => {
                                        return (
                                            <ListItem key={index}>
                                                <Chip label={data} onDelete={() => handleDelete(data, 'email1')} />
                                            </ListItem>
                                        );
                                    })}
                                </ul>
                                :
                                ""
                            }
                            <input type='email' value={email1} placeholder='Escalation Email-1' className='form-control' onChange={(event) => escInput(event, 'email1')} onKeyDown={(event) => inputKeyDown(event, 'email1')} onPaste={(event) => emailPaste(event, 'email1')} />
                            {
                                emailError1 &&
                                <p className="emailError">{emailError1}</p>
                            }
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-4'>
                            <p>Escalation Email-2</p>
                        </div>
                        <div className='col-8'>
                            {emailArray2.length ?
                                <ul className='chipList'>
                                    {emailArray2.map((data, index) => {
                                        return (
                                            <ListItem key={index}>
                                                <Chip label={data} onDelete={() => handleDelete(data, 'email2')} />
                                            </ListItem>
                                        );
                                    })}
                                </ul>
                                :
                                ""
                            }
                            <input type='email' value={email2} placeholder='Escalation Email-2' className='form-control' onChange={(event) => escInput(event, 'email2')} onKeyDown={(event) => inputKeyDown(event, 'email2')} onPaste={(event) => emailPaste(event, 'email2')} />
                            {
                                emailError2 &&
                                <p className="emailError">{emailError2}</p>
                            }
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-4'>
                            <p>Escalation Email-3</p>
                        </div>
                        <div className='col-8'>
                            {emailArray3.length ?
                                <ul className='chipList'>
                                    {emailArray3.map((data, index) => {
                                        return (
                                            <ListItem key={index}>
                                                <Chip label={data} onDelete={() => handleDelete(data, 'email3')} />
                                            </ListItem>
                                        );
                                    })}
                                </ul>
                                :
                                ""
                            }
                            <input type='email' value={email3} placeholder='Escalation Email-3' className='form-control' onChange={(event) => escInput(event, 'email3')} onKeyDown={(event) => inputKeyDown(event, 'email3')} onPaste={(event) => emailPaste(event, 'email3')} />
                            {
                                emailError3 &&
                                <p className="emailError">{emailError3}</p>
                            }
                        </div>
                    </div>
                </fieldset>
                <fieldset className='fieldset'>
                    <legend>Escalation SMS</legend>
                    <div className='row'>
                        <div className='col-4'>
                            <p>Escalation SMS-1 <span><sup>*</sup></span></p>
                        </div>
                        <div className='col-8'>
                            {smsArray1.length ?
                                <ul className='chipList'>
                                    {smsArray1.map((data, index) => {
                                        return (
                                            <ListItem key={index}>
                                                <Chip label={data} onDelete={() => handleDelete(data, 'sms1')} />
                                            </ListItem>
                                        );
                                    })}
                                </ul>
                                :
                                ""
                            }
                            <PhoneInput international
                                // defaultCountry="IN" countryCallingCodeEditable={false} 
                                type='tel' value={sms1} placeholder='Escalation SMS-1' className={sms1 ? ((sms1 && isValidPhoneNumber(sms1)) ? 'form-control telValid' : 'form-control telInValid') : 'form-control'} error={sms1 ? (isValidPhoneNumber(sms1) ? undefined : 'Invalid phone number') : 'Phone number required'}
                                onChange={(setSms1) => escInput(setSms1, 'sms1')} onKeyDown={(event) => inputKeyDown(event, 'sms1')} />
                            {
                                smsError1 &&
                                <p className="emailError">{smsError1}</p>
                            }
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-4'>
                            <p>Escalation SMS-2</p>
                        </div>
                        <div className='col-8'>
                            {smsArray2.length ?
                                <ul className='chipList'>
                                    {smsArray2.map((data, index) => {
                                        return (
                                            <ListItem key={index}>
                                                <Chip label={data} onDelete={() => handleDelete(data, 'sms2')} />
                                            </ListItem>
                                        );
                                    })}
                                </ul>
                                :
                                ""
                            }
                            <PhoneInput international
                                // defaultCountry="IN" countryCallingCodeEditable={false} 
                                type='tel' value={sms2} placeholder='Escalation SMS-2' className={sms2 ? ((sms2 && isValidPhoneNumber(sms2)) ? 'form-control telValid' : 'form-control telInValid') : 'form-control'} onChange={(setSms2) => escInput(setSms2, 'sms2')} onKeyDown={(event) => inputKeyDown(event, 'sms2')} />
                            {
                                smsError2 &&
                                <p className="emailError">{smsError2}</p>
                            }
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-4'>
                            <p>Escalation SMS-3</p>
                        </div>
                        <div className='col-8'>
                            {smsArray3.length ?
                                <ul className='chipList'>
                                    {smsArray3.map((data, index) => {
                                        return (
                                            <ListItem key={index}>
                                                <Chip label={data} onDelete={() => handleDelete(data, 'sms3')} />
                                            </ListItem>
                                        );
                                    })}
                                </ul>
                                :
                                ""
                            }
                            <PhoneInput international
                                // defaultCountry="IN" countryCallingCodeEditable={false} 
                                type='tel' value={sms3} placeholder='Escalation SMS-3' className={sms3 ? ((sms3 && isValidPhoneNumber(sms3)) ? 'form-control telValid' : 'form-control telInValid') : 'form-control'} onChange={(setSms3) => escInput(setSms3, 'sms3')} onKeyDown={(event) => inputKeyDown(event, 'sms3')} />
                            {
                                smsError3 &&
                                <p className="emailError">{smsError3}</p>
                            }
                        </div>
                    </div>
                </fieldset>
                {/* <fieldset className='fieldset'>
                    <legend>Mapping Stream</legend>
                    <div className='row'>
                        <div className='col-4'>
                            <p>Mapping stream Name</p>
                        </div>
                        <div className='col-8'>
                            <input type='text' placeholder='Mapping stream Name' className='form-control' value={streamName} onChange={(e) => setStreamName(e.target.value)} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-4'>
                            <p>Mapping stream URL</p>
                        </div>
                        <div className='col-8'>
                            <input type='text' placeholder='Mapping stream URL' className='form-control' value={streamUrl} onChange={(e) => setStreamUrl(e.target.value)} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-4'>
                            <p>Mapping stream Description</p>
                        </div>
                        <div className='col-8'>
                            <input type='text' placeholder='Mapping stream Description' className='form-control' value={streamDesc} onChange={(e) => setstreamDesc(e.target.value)} />
                        </div>
                    </div>
                </fieldset> */}
                <div className='row'>
                    <div className='col-12'>
                        <Button onClick={onSave} variant='contained'>Save</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddNotifi